import type { Edge } from "reactflow";

import type { ExecutableJourneyNode } from "src/pages/journeys/types";
import { getOutgoersSafe } from ".";

/**
 * Helper function to get all downstream nodes recursively
 */
export const getDownstreamNodes = (
  node: ExecutableJourneyNode,
  nodes: ExecutableJourneyNode[],
  edges: Edge[],
  visited = new Set<string>(),
): string[] => {
  if (visited.has(node.id)) return [];
  visited.add(node.id);

  const outgoers = getOutgoersSafe(node, nodes, edges);

  const result = [node.id];
  outgoers.forEach((targetId) => {
    // Accumulate downstream node ids from each outgoer
    result.push(...getDownstreamNodes(targetId, nodes, edges, visited));
  });

  return result;
};
